const $ = window.jQuery;

function doRequestHelper(urlBase) {
    return (type, method, data) => {
        const [actionName, methodName] = method.split('/');
        const urlConnector = urlBase.indexOf('?') === -1 ? '?' : '&';
        const urlQuery = `action=${actionName}&method=${methodName}`;

        return $.ajax({
            type,
            dataType: 'json',
            url: `${urlBase}${urlConnector}${urlQuery}`,
            data,
        });
    };
}

export default doRequestHelper;
